/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';

// material-ui
import { Grid, Stack, Chip, Button, MenuItem, Menu, Checkbox, FormControlLabel } from '@mui/material';

// assets
import AnimateButton from 'ui-component/extended/AnimateButton';

// project imports
import useLeagues from 'hooks/useLeagues';
import { dispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';

const ActionsChip = ({ team, onClickSubButton }) => {
    const { deleteUserFromPlayingGroup, putUserPlayingGroup, setEventPools, setEventMatchups, eventMatchups, getLeagueGroupMatches } =
        useLeagues();
    const [isSub, setIsSub] = useState(team?.is_sub === 1);
    const [isWithdrawn, setIsWithdrawn] = useState(team?.absent === 1);
    const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

    useEffect(() => {
        getLeagueGroupMatches(team?.playing_group_id).then((res) => {
            if (res) {
                setEventMatchups(res?.matches);
            } else {
                setEventMatchups([]);
            }
        });
    }, [team]);

    const handleIsSubCheckboxChange = (event) => {
        const newValue = event.target.checked ? 1 : 0;
        putUserPlayingGroup(team?.id, { is_sub: newValue }).then((res) => console.log('res', res));
        setIsSub(event.target.checked);

        setEventPools((prevEventPools) =>
            prevEventPools.map((eventPool) => ({
                ...eventPool,
                pool_teams: eventPool.pool_teams.map((prevTeam) => (prevTeam.id === team?.id ? { ...team, is_sub: newValue } : prevTeam))
            }))
        );
    };

    const handleIsWithdrawnCheckboxChange = (event) => {
        const newValue = event.target.checked ? 1 : 0;
        putUserPlayingGroup(team?.id, { absent: newValue }).then((res) => console.log('res', res));
        setIsWithdrawn(event.target.checked);

        setEventPools((prevEventPools) =>
            prevEventPools.map((eventPool) => ({
                ...eventPool,
                pool_teams: eventPool.pool_teams.map((prevTeam) => (prevTeam.id === team?.id ? { ...team, absent: newValue } : prevTeam))
            }))
        );
    };

    const handleMenuClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleClose = () => setMenuAnchorEl(null);

    function handleSubButtonClick() {
        handleClose();
        onClickSubButton(team?.user);
    }

    function isUserPresent(userId, playingGroupId) {
        return eventMatchups.some((matchup) => {
            // Ensure the matchup belongs to the specified playing group
            if (matchup.playing_group_id !== playingGroupId) {
                return false;
            }

            // Check team A players for the given userId
            const teamAHasUser =
                matchup.team_a &&
                Array.isArray(matchup.team_a.players) &&
                matchup.team_a.players.some((player) => player.user_id === userId);

            // Check team B players for the given userId
            const teamBHasUser =
                matchup.team_b &&
                Array.isArray(matchup.team_b.players) &&
                matchup.team_b.players.some((player) => player.user_id === userId);

            return teamAHasUser || teamBHasUser;
        });
    }

    function handleDeleteButtonClick() {
        handleClose();
        if (!isUserPresent(team?.user_id, team?.playing_group_id)) {
            deleteUserFromPlayingGroup(team?.id).then((res) =>
                dispatch(
                    openSnackbar({
                        open: true,
                        message: 'Player deleted',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: true
                    })
                )
            );
            const teamId = team?.id;
            setEventPools((prevEventPools) =>
                prevEventPools.map((eventPool) => ({
                    ...eventPool,
                    pool_teams: eventPool.pool_teams.filter((prevTeam) => prevTeam.id !== teamId)
                }))
            );
        } else {
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Player has active matches',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        }
    }

    return (
        <>
            <Chip
                size="medium"
                label="Actions"
                onClick={(e) => handleMenuClick(e)}
                sx={{
                    mt: 1,
                    // pl: 1.5,
                    // width: 40,
                    // height: 40,
                    borderRadius: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                    // color: 'white'
                }}
            />
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                keepMounted
                onClose={handleClose}
                variant="selectedMenu"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <MenuItem>
                    <FormControlLabel control={<Checkbox onChange={handleIsSubCheckboxChange} />} label="Is A Sub" checked={isSub} />
                </MenuItem>
                <MenuItem>
                    <FormControlLabel
                        control={<Checkbox onChange={handleIsWithdrawnCheckboxChange} />}
                        label="Is Withdrawn"
                        checked={isWithdrawn}
                    />
                </MenuItem>
                <MenuItem>
                    <AnimateButton>
                        <Button type="submit" variant="contained" color="warning" onClick={() => handleSubButtonClick()}>
                            Sub
                        </Button>
                    </AnimateButton>
                </MenuItem>
                <MenuItem>
                    <AnimateButton>
                        <Button type="submit" variant="contained" color="error" onClick={() => handleDeleteButtonClick()}>
                            Delete
                        </Button>
                    </AnimateButton>
                </MenuItem>
            </Menu>
        </>
    );
};

const EditPlayerPool = ({ team, onClickSubButton }) => (
    <Grid item xs={12}>
        <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
            <ActionsChip onClickSubButton={onClickSubButton} team={team} />
        </Stack>
    </Grid>
);
export default EditPlayerPool;
